import {ICrmSystem} from "./types";

export enum CrmSystemTypes {
    GET_CRM_SYSTEM = "@@CRM_SYSTEM/GET_CRM_SYSTEM",
    GET_CRM_SYSTEM_SUCCESS = "@@CRM_SYSTEM/GET_CRM_SYSTEM_SUCCESS",

    GET_CRM_SYSTEMS = "@@CRM_SYSTEM/GET_CRM_SYSTEMS",
    GET_CRM_SYSTEMS_SUCCESS = "@@CRM_SYSTEM/GET_CRM_SYSTEMS_SUCCESS",

    ADD_CRM_SYSTEM = "@@CRM_SYSTEM/ADD_CRM_SYSTEM",
    ADD_CRM_SYSTEM_SUCCESS = "@@CRM_SYSTEM/ADD_CRM_SYSTEM_SUCCESS",

    UPDATE_CRM_SYSTEM = "@@CRM_SYSTEM/UPDATE_CRM_SYSTEM",
    UPDATE_CRM_SYSTEM_SUCCESS = "@@CRM_SYSTEM/UPDATE_CRM_SYSTEM_SUCCESS",

    DELETE_CRM_SYSTEM = "@@CRM_SYSTEM/DELETE_CRM_SYSTEM",
    DELETE_CRM_SYSTEM_SUCCESS = "@@CRM_SYSTEM/DELETE_CRM_SYSTEM_SUCCESS",

    FAIL_CRM_SYSTEMS = "@@CRM_SYSTEM/FAIL_CRM_SYSTEMS",

    CLEAR_CRM_SYSTEM = "@@CRM_SYSTEM/CLEAR_CRM_SYSTEM",
    CLEAR_CRM_SYSTEMS = "@@CRM_SYSTEM/CLEAR_CRM_SYSTEMS",

    MODAL_CRM_SYSTEM = "@@CRM_SYSTEM/MODAL_CRM_SYSTEM",
}

export interface CrmSystemState {
    data: Array<ICrmSystem>;
    item: ICrmSystem | null;

    pagination: Object;
    error: Object;
    loading: boolean,
    loaded: boolean,

    isOpenModal: boolean,
}

